export default {
  PAGE: 1,
  ORDER: 'DESC',
  LSTCNT: 3,
  PGCNT: 10,
  TOTCNT: 0,
}
